export const QUERY_NAME = 'JiraBusinessCalendarPaginatedReleases';

export const QUERY = `
  query ${QUERY_NAME}($projectAri: ID!, $releaseDateAfter: Date, $releaseDateBefore: Date, $first: Int) {
    jira {
      versionsForProject(
        jiraProjectId: $projectAri
        filter: [RELEASED, UNRELEASED]
        first: $first
        releaseDateAfter: $releaseDateAfter
        releaseDateBefore: $releaseDateBefore
      ) {
        edges {
          cursor
          node {
            id
            versionId
            name
            iconUrl
            status
            description
            startDate
            releaseDate
            project {
                key
                name
                avatar {
                  large
                }
            }
            doneIssues: issues(filter: DONE) {
              totalCount
            }
            inprogressIssues: issues(filter: IN_PROGRESS) {
              totalCount
            }
            todoIssues: issues(filter: TODO) {
              totalCount
            }
          }
        }
        pageInfo {
            endCursor
            hasNextPage
        }
      }
    }
  }
`;
